import React from 'react'
import { Segment, CurrencyField, FundDistribution } from 'components'
import styles from './PaymentAllocation.module.scss'

interface PaymentAllocationProps {
  invoiceType: {
    name: string
    value: string
  }
  amount: string
  amountVatApplied?: boolean
  onAmountChange?: (e: any) => void
  onVatChange?: (e: any) => void
  onBeneficiaryVatChange?: (index: number, vat: any) => void
  onDepositBeneficiaryTransferChange?: (beneficiary: any) => void
  beneficiaries?: Array<{
    beneficiary: {
      type: string
      value: {
        name: string
        partyId: string | null
        partyTag: string | null
        reference: string | null
        amount: number | string | null
        vat: boolean | null
      }
    }
  }>
  onNewBeneficiaryAdded?: (beneficiary: any, index: number) => void
  onBeneficiaryRemoved?: (beneficiary: any) => void
  onNewBeneficiaryAmountChange?: (beneficiaryIndex: number, e: any) => void
  onBeneficiariesOrderChange?: (beneficiaries: any) => void
  partyTags?: Array<{
    value: string
    label: string
  }>
}

interface AmountProps {
  invoiceType: string
  amount: string
  amountVatApplied?: boolean
  onAmountChange?: (e: any) => void
  onVatChange?: (e: any) => void
}

const Amount = ({
  invoiceType,
  amount,
  amountVatApplied,
  onAmountChange,
  onVatChange,
}: AmountProps): React.ReactElement => {
  return (
    <Segment horizontal state={'default'}>
      <Segment.Label text={invoiceType} />
      <div className={styles.amount}>
        <CurrencyField
          includeVatControl
          name="amount"
          placeholder="Enter amount"
          onChange={onAmountChange}
          value={amount}
          onToggleChange={onVatChange}
          vatApplied={amountVatApplied}
        />
      </div>
    </Segment>
  )
}

const PaymentAllocation = ({
  invoiceType,
  amount,
  onAmountChange = (e: any) => e,
  beneficiaries = [],
  onNewBeneficiaryAdded = (beneficiary: any) => beneficiary,
  onBeneficiaryRemoved,
  onNewBeneficiaryAmountChange,
  onDepositBeneficiaryTransferChange,
  onBeneficiariesOrderChange,
  onVatChange,
  amountVatApplied,
  onBeneficiaryVatChange,
  partyTags,
}: PaymentAllocationProps) => {
  return (
    <div className={styles.root}>
      <FundDistribution
        invoiceType={invoiceType}
        headerText="Payment Allocation"
        beforeContent={
          <Amount
            amount={amount}
            invoiceType={invoiceType.name}
            onVatChange={onVatChange}
            onAmountChange={onAmountChange}
            amountVatApplied={amountVatApplied}
          />
        }
        balance={parseFloat(amount)}
        onNewBeneficiaryAdded={onNewBeneficiaryAdded}
        onBeneficiaryRemoved={onBeneficiaryRemoved}
        onNewBeneficiaryAmountChange={onNewBeneficiaryAmountChange}
        onDepositBeneficiaryTransferChange={onDepositBeneficiaryTransferChange}
        onBeneficiariesOrderChange={onBeneficiariesOrderChange}
        invoiceStatus={'Ready'}
        beneficiaries={beneficiaries}
        partySearchTags=""
        partyTags={partyTags}
        onVatChange={onBeneficiaryVatChange}
      />
    </div>
  )
}

export default PaymentAllocation
